import React from 'react';
import { MuiThemeProvider, createMuiTheme, Theme } from '@material-ui/core';
import { AD } from './adsAgentTokens';

const adsAgentTheme = (outer: Theme): Theme =>
  createMuiTheme({
    ...outer,
    palette: {
      ...outer.palette,
      primary: { main: AD.primary, light: AD.primarySoft },
    },
    typography: {
      ...outer.typography,
      h3: { fontFamily: 'Inter', fontSize: 20 },
      h4: { fontFamily: 'Inter', fontSize: 16 },
      h5: { fontFamily: 'Inter', fontSize: 14, fontWeight: 400 },
      h6: { fontSize: 12, fontWeight: 400 },
      body1: { fontFamily: 'Roboto', fontSize: 14 },
      body2: { fontFamily: 'Roboto', fontSize: 12 },
    },
  });

const AdsAgentThemeProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => (
  <MuiThemeProvider theme={adsAgentTheme}>{children}</MuiThemeProvider>
);

export default AdsAgentThemeProvider;
